<template>
    <div>
        <b-modal
            ref="confirmModal"
            title="Delete Customer"
            @ok="deleteCustomer"
        >
            <p>Are you sure you want to delete customer {{ customer.company_name }}?</p>
        </b-modal>
        <b-modal
            ref="deletedModal"
            title="Customer Deleted"
            ok-only
            @ok="deletedOk"
        >
            <p>Customer was successfully deleted</p>
        </b-modal>
        <b-modal
            ref="errorModal"
            title="Error"
            ok-only
            header-bg-variant="danger"
            header-text-variant="light"
        >
            <p>There was a problem deleting this customer</p>
        </b-modal>
    </div>
</template>

<script>
import CustomerService from "../../../services/CustomerService";

export default {
    props: ["customer"],
    data: function() {
        return {
            service: CustomerService
        };
    },
    methods: {
        show: function() {
            this.$refs.confirmModal.show();
        },

        deleteCustomer: function() {
            this.service.delete(this.customer).then(
                () => {
                    this.$refs.deletedModal.show();
                },
                () => {
                    this.$refs.errorModal.show();
                }
            );
        },

        deletedOk: function() {
            this.$router.push({ name: 'office.customers', query: { deleted: "true" } });
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/customers/DeleteComponent.vue